import { createContext } from 'react';
export var DimeStateContext = createContext({
    dialogState: undefined,
    convertedToPaid: undefined,
});
export var DimeActionCreatorsContext = createContext({
    setDialogState: function (_dialogState) {
        /* no op */
    },
    setConvertedToPaid: function (_convertedToPaid) {
        /* no op */
    },
});
//# sourceMappingURL=context.js.map